import { render } from "./DevopsLogs.vue?vue&type=template&id=2ad18ac2&scoped=true"
import script from "./DevopsLogs.vue?vue&type=script&lang=js"
export * from "./DevopsLogs.vue?vue&type=script&lang=js"

import "./DevopsLogs.vue?vue&type=style&index=0&id=2ad18ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad18ac2"]])

export default __exports__